import { useEffect, useState } from 'react';
import { normalizeError } from 'core/common/errors';
import { useDispatch, useServices, useUrlLocation } from 'core/common/hooks';
import { getQueryParams } from 'core/common/utils/getQueryParams';
import { useEmailFlow } from 'core/flow/hooks';
import { useFunnelData } from 'core/funnel/contexts';
import { useUser, useUtmTags } from 'core/user/hooks';
import { updateUserInformation } from 'core/user/store';
import { OrderDTO } from '../services/dto';
import { updateOrderId } from '../store/actions';

// TODO move to thunk
export function useGetOrder() {
  const [order, setOrder] = useState<OrderDTO>();

  const dispatch = useDispatch();
  const { location } = useUrlLocation();
  const { purchaseService, userService, loggingService: logger } = useServices();
  const { syncUtmTags } = useUtmTags();
  const { updateUserPreferences } = useUser();
  const { flow, name: funnelName } = useFunnelData();

  const searchParams = new URLSearchParams(location.query as unknown as string);

  const { order_id } = getQueryParams<{ order_id: string }>();

  const { getEmailFlow } = useEmailFlow();

  useEffect(() => {
    if (!order_id) {
      return;
    }

    async function fetchOrderInfo() {
      const emailFlow = getEmailFlow(flow.attributes?.emailFlowAttributes);
      const res = await purchaseService.getOrder(order_id, searchParams.toString());

      if (res) {
        const userId = res.user_id;
        updateUserPreferences(res.order_quiz_data);
        dispatch(updateUserInformation('orderData', { subjects: res.order_data.subjects }));
        logger.info('EmailFlow: sending emailFlow to the backend with the orders query', {
          emailFlow,
          userId,
          email: res.order_quiz_data.email,
          funnel: funnelName,
          nfb_flow: flow.name,
        });
        try {
          await userService.setEmailFlow({ emailFlow, userId });
        } catch (error) {
          const normalizedError = normalizeError(error);
          logger.error('EmailFlow: failed to setEmailFlow', { error: normalizedError });
        }
      }

      dispatch(updateOrderId(order_id));
      syncUtmTags({ user_id: res.user_id, email: res.order_quiz_data.email });

      setOrder(res);
    }

    fetchOrderInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    order,
  };
}
